import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, useTranslation } from '@pascal/pascal-core';
import { liveBetsDataStore } from '../../store/liveBetsDataStore';

export const LiveBets = observer(() => {
  const { liveBets } = liveBetsDataStore;
  const t = useTranslation();
  return (
    <div className='tb-left-comb-table-inner'>
      <div className='tb-left-comb-table-inner-top'>
        <div className='comb-table-row-header'>
          <div className='comb-table-row-h-cl'>
            <span className='comb-table-row-h-cl-txt'>{t('USER')}</span>
          </div>
          <div className='comb-table-row-h-cl'>
            <span className='comb-table-row-h-cl-txt'>{t('BET_AMOUNT')}</span>
          </div>
          <div className='comb-table-row-h-cl'>
            <span className='comb-table-row-h-cl-txt'>{t('PAYOUT')}</span>
          </div>
        </div>
      </div>
      <div className='tb-left-comb-table-inner-cont'>
        <div className='scrollable-container'>
          <div className='tb-comb-t-wrp'>
            {liveBets.map(({ userId, amount, winAmount, id }) => (
              <div className='tb-comb-t-row' key={id}>
                <div className='tb-comb-t-row-inner'>
                  <div className='tb-comb-t-row-cl'>
                    <p className='tb-comb-t-row-cl-txt'>id: {userId}</p>
                  </div>
                  <div className='tb-comb-t-row-cl'>
                    <p className='tb-comb-t-row-cl-txt'>{convertAmount(amount)}</p>
                  </div>
                  <div className='tb-comb-t-row-cl'>
                    <p className='tb-comb-t-row-cl-txt'>{convertAmount(winAmount)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});
